module.exports = __webpack_public_path__ + "static/media/event.4c7e9033.png";